import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/app/ui/assets/svg/chevron-down-black.svg'


const _hoisted_1 = { class: "text-base font-semibold text-gray-lp-300" }
const _hoisted_2 = { class: "space-y-1 px-2" }
const _hoisted_3 = { class: "flex flex-col gap-1 pb-2" }
const _hoisted_4 = { class: "flex flex-row gap-3" }
const _hoisted_5 = { class: "font-medium text-sm text-gray-lp-600 w-1/2" }
const _hoisted_6 = { class: "font-medium text-sm text-gray-lp-600 w-1/2" }
const _hoisted_7 = { class: "flex flex-row gap-3" }
const _hoisted_8 = {
  class: "font-semibold text-base text-gray-lp-300 w-1/2",
  "data-testid": "pr-detail-gross-weight"
}
const _hoisted_9 = {
  class: "font-semibold text-base text-gray-lp-300 w-1/2",
  "data-testid": "pr-detail-dimension"
}
const _hoisted_10 = { class: "flex flex-col gap-1 pb-2" }
const _hoisted_11 = { class: "flex flex-row gap-3" }
const _hoisted_12 = { class: "font-medium text-sm text-gray-lp-600 w-1/2" }
const _hoisted_13 = { class: "font-medium text-sm text-gray-lp-600 w-1/2" }
const _hoisted_14 = { class: "flex flex-row gap-3" }
const _hoisted_15 = {
  class: "font-semibold text-base text-gray-lp-300 w-1/2",
  "data-testid": "pr-detail-chargeable-weight"
}
const _hoisted_16 = {
  class: "font-semibold text-base text-gray-lp-300 w-1/2",
  "data-testid": "pr-detail-koli"
}
const _hoisted_17 = { class: "flex flex-col gap-1 pb-2" }
const _hoisted_18 = { class: "flex flex-row gap-3" }
const _hoisted_19 = { class: "font-medium text-sm text-gray-lp-600 w-1/2" }
const _hoisted_20 = { class: "font-medium text-sm text-gray-lp-600 w-1/2" }
const _hoisted_21 = { class: "flex flex-row gap-3" }
const _hoisted_22 = {
  class: "font-semibold text-base text-gray-lp-300 w-1/2",
  "data-testid": "pr-detail-cod-amount"
}
const _hoisted_23 = {
  class: "font-semibold text-base text-gray-lp-300 w-1/2",
  "data-testid": "pr-detail-goods-price"
}
const _hoisted_24 = { class: "flex flex-col gap-1 pb-2" }
const _hoisted_25 = { class: "font-medium text-sm text-gray-lp-600" }
const _hoisted_26 = { class: "font-semibold text-base text-gray-lp-300" }
const _hoisted_27 = { class: "flex flex-col gap-1" }
const _hoisted_28 = { class: "font-medium text-sm text-gray-lp-600" }
const _hoisted_29 = { class: "flex flex-row gap-1" }
const _hoisted_30 = { class: "overflow-ellipsis overflow-hidden whitespace-nowrap" }
const _hoisted_31 = { class: "flex flex-col text-12px" }
const _hoisted_32 = { class: "font-bold" }
const _hoisted_33 = {
  key: 0,
  class: "flex flex-row gap-1 justify-end items-center"
}
const _hoisted_34 = {
  key: 0,
  class: "bg-yellow-lp-200 rounded text-center text-yellow-lp-100 font-medium text-xs px-1"
}
const _hoisted_35 = {
  key: 1,
  class: "ml-1 bg-red-lp-600 rounded text-center text-red-lp-1600 font-medium text-xs px-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!

  return (_openBlock(), _createBlock("div", {
    class: 
      `${
        _ctx.isCollapsed ? '' : 'pb-2'
      } pt-2 bg-white rounded-lg border border-gray-lp-1400 mt-2`
    
  }, [
    _createVNode("div", {
      class: 
        `${
          _ctx.isCollapsed ? '' : 'mb-2'
        } pb-2 flex items-center justify-between border-b px-2`
      
    }, [
      _createVNode("h2", _hoisted_1, _toDisplayString(_ctx.$t("pusatResolusi.detail.detailGoods")), 1),
      _createVNode("button", {
        class: "p-2 hover:bg-gray-100 rounded-full",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleCollapse && _ctx.toggleCollapse(...args)))
      }, [
        _createVNode("img", {
          src: _imports_0,
          class: ["w-6 h-6 transition-transform duration-200", { 'transform rotate-180': !_ctx.isCollapsed }],
          alt: "chevron"
        }, null, 2)
      ])
    ], 2),
    _withDirectives(_createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("pusatResolusi.detail.grossWeight")), 1),
          _createVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("pusatResolusi.detail.dimension")), 1)
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode("div", _hoisted_8, _toDisplayString(_ctx.formatWeight(_ctx.summary.grossWeight)), 1),
          _createVNode("div", _hoisted_9, _toDisplayString(_ctx.formatDimension(
                _ctx.summary.dimLength,
                _ctx.summary.dimWidth,
                _ctx.summary.dimHeight
              )), 1)
        ])
      ]),
      _createVNode("div", _hoisted_10, [
        _createVNode("div", _hoisted_11, [
          _createVNode("div", _hoisted_12, _toDisplayString(_ctx.$t("pusatResolusi.detail.chargeableWeight")), 1),
          _createVNode("div", _hoisted_13, _toDisplayString(_ctx.$t("pusatResolusi.detail.koli")), 1)
        ]),
        _createVNode("div", _hoisted_14, [
          _createVNode("div", _hoisted_15, _toDisplayString(_ctx.formatWeight(_ctx.summary.chargeableWeight)), 1),
          _createVNode("div", _hoisted_16, _toDisplayString(_ctx.formatQuantity(_ctx.summary.totalPiece)), 1)
        ])
      ]),
      _createVNode("div", _hoisted_17, [
        _createVNode("div", _hoisted_18, [
          _createVNode("div", _hoisted_19, _toDisplayString(_ctx.$t("pusatResolusi.detail.codCharge")), 1),
          _createVNode("div", _hoisted_20, _toDisplayString(_ctx.$t("pusatResolusi.detail.goodsPrice")), 1)
        ]),
        _createVNode("div", _hoisted_21, [
          _createVNode("div", _hoisted_22, _toDisplayString(_ctx.formatPriceNumber(_ctx.summary.codAmount)), 1),
          _createVNode("div", _hoisted_23, _toDisplayString(_ctx.formatPriceNumber(_ctx.summary.goodsPrice)), 1)
        ])
      ]),
      _createVNode("div", _hoisted_24, [
        _createVNode("div", _hoisted_25, _toDisplayString(_ctx.$t("pusatResolusi.detail.insurance")), 1),
        _createVNode("div", _hoisted_26, _toDisplayString(_ctx.summary.isInsurance
              ? _ctx.$t("pusatResolusi.detail.yes")
              : _ctx.$t("pusatResolusi.detail.no")), 1)
      ]),
      _createVNode("div", _hoisted_27, [
        _createVNode("div", _hoisted_28, _toDisplayString(_ctx.$t("pusatResolusi.detail.commodity")), 1),
        _createVNode("div", _hoisted_29, [
          _createVNode("div", _hoisted_30, [
            _createVNode("div", {
              class: "font-semibold text-base overflow-ellipsis overflow-hidden whitespace-nowrap text-gray-lp-300 cursor-default",
              onMouseenter: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleTooltip($event))),
              onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggleTooltip($event)))
            }, _toDisplayString(_ctx.summary.commodityName), 33),
            _createVNode(_component_OverlayPanel, {
              ref: "commodityName",
              appendTo: "body",
              style: {
                backgroundColor: '#4D4D4D',
                color: '#ffffff'
              }
            }, {
              default: _withCtx(() => [
                _createVNode("div", _hoisted_31, [
                  _createVNode("div", _hoisted_32, _toDisplayString(_ctx.summary.commodityName), 1)
                ])
              ]),
              _: 1
            }, 512)
          ]),
          (_ctx.summary.commodityIsQuarantine || _ctx.summary.commodityIsDg)
            ? (_openBlock(), _createBlock("div", _hoisted_33, [
                (_ctx.summary.commodityIsQuarantine)
                  ? (_openBlock(), _createBlock("span", _hoisted_34, " K "))
                  : _createCommentVNode("", true),
                (_ctx.summary.commodityIsDg)
                  ? (_openBlock(), _createBlock("span", _hoisted_35, " DG "))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ], 512), [
      [_vShow, !_ctx.isCollapsed]
    ])
  ], 2))
}